import React, { useCallback, useEffect, useState } from 'react';
import { getComposerSmsSettings, updateComposerSmsSettings } from '../../../services/aiComposer';
import './ComposerSmsSettings.css';

export default function ComposerSmsSettings({ token }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState(null);
  const [morningTime, setMorningTime] = useState('08:00');
  const [morningTimezone, setMorningTimezone] = useState('America/Los_Angeles');

  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await getComposerSmsSettings(token);
      const s = res.data.settings;
      setSettings(s);
      setMorningTime(s?.morningTime || '08:00');
      setMorningTimezone(s?.morningTimezone || 'America/Los_Angeles');
    } catch (err) {
      console.error('ComposerSmsSettings load failed:', err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const save = async (patch) => {
    if (!token) return;
    setSaving(true);
    try {
      const res = await updateComposerSmsSettings(token, patch);
      setSettings(res.data.settings);
    } catch (err) {
      console.error('ComposerSmsSettings save failed:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleMorningTimeBlur = () => {
    if (morningTime !== settings?.morningTime) {
      save({ morningTime, morningTimezone });
    }
  };

  return (
    <div className="composerSmsSettings">
      <button
        type="button"
        className="composerSmsSettingsToggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        SMS composer {settings?.optIn ? '(on)' : '(off)'}
      </button>
      {open && (
        <div className="composerSmsSettingsPanel">
          {loading ? (
            <p className="composerSmsSettingsHint">Loading…</p>
          ) : (
            <>
              <p className="composerSmsSettingsHint">
                After you connect a screen, your composer may text you to continue the conversation here.
                {!settings?.optIn && ' Reply YES to that message to opt in.'}
              </p>
              {settings?.phoneNumber && (
                <p className="composerSmsSettingsPhone">Phone on file: {settings.phoneNumber}</p>
              )}
              <label className="composerSmsSettingsRow">
                <input
                  type="checkbox"
                  checked={!!settings?.optIn}
                  disabled={saving}
                  onChange={(e) => save({ optIn: e.target.checked })}
                />
                SMS composer enabled
              </label>
              <label className="composerSmsSettingsRow">
                <input
                  type="checkbox"
                  checked={!!settings?.morningEnabled}
                  disabled={saving || !settings?.optIn}
                  onChange={(e) => save({ morningEnabled: e.target.checked })}
                />
                Daily morning suggestions
              </label>
              <label className="composerSmsSettingsRow">
                Morning time
                <input
                  type="time"
                  value={morningTime}
                  disabled={saving || !settings?.optIn}
                  onChange={(e) => setMorningTime(e.target.value)}
                  onBlur={handleMorningTimeBlur}
                />
              </label>
              <label className="composerSmsSettingsRow">
                Timezone
                <input
                  type="text"
                  value={morningTimezone}
                  disabled={saving || !settings?.optIn}
                  onChange={(e) => setMorningTimezone(e.target.value)}
                  onBlur={() => {
                    if (morningTimezone !== settings?.morningTimezone) {
                      save({ morningTime, morningTimezone });
                    }
                  }}
                  placeholder="America/Los_Angeles"
                />
              </label>
            </>
          )}
        </div>
      )}
    </div>
  );
}
